import { axiosInstance } from '../../api/api';
import * as ActionTypes from '../actionTypes';
import { updateReceivePart } from './receivePart';
import { updateCurrentLineItem } from './station';

export const submitMarkUnprocessed =
	(sequenceNumber, payload, successCallback, errorCallback) => () => {
		axiosInstance
			.post(`/station/parts/${sequenceNumber}/take-out`, { ...payload })
			.then(() => {
				successCallback();
			})
			.catch((err) => {
				// console.log('err', err);
				errorCallback(err);
			});
	};

export const getPartValidationDetailsForSerialNumber =
	(successCallback, errorCallback, serialNumber) => (dispatch) => {
		axiosInstance
			.get(`/station/part-validation/${serialNumber}`)
			.then(({ data }) => {
				const updatedScanJobDetails = data.scanJobDetails.map((scanJob) => {
					const scanJobResults = scanJob.scanJobResults.map((scanJobResult) => {
						return {
							...scanJobResult,
							displaySerialNumber: scanJobResult.scannedSerialNumber,
						};
					});

					return { ...scanJob, scanJobResults };
				});
				const updatedData = { ...data, scanJobDetails: updatedScanJobDetails };
				dispatch(updatePartValidation({ ...updatedData, serialNumber }));
				successCallback(data);
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export const skipPartScanning =
	(sequenceNumber, payload, successCallback, errorCallback) =>
	(dispatch, getState) => {
		axiosInstance
			.post(`/station/part-validation/${sequenceNumber}/skip`, { ...payload })
			.then((response) => {
				const { partValidation } = getState();
				const { data } = response;

				const scanJobDetails = data.scanJobDetails.map((scanJob) => {
					if (scanJob.familyId === payload.familyId) {
						const scanJobResults = scanJob.scanJobResults.map(
							(scanJobResult, index) => {
								if (index === scanJob.scanJobResults.length - 1) {
									return {
										...scanJobResult,
										displaySerialNumber: payload.scannedSerialNumber,
									};
								}
								return {
									...scanJobResult,
									displaySerialNumber: scanJobResult.scannedSerialNumber,
								};
							},
						);

						return { ...scanJob, scanJobResults };
					}
					return { ...scanJob };
				});

				const updatedData = { ...partValidation, scanJobDetails };
				dispatch(updatePartValidation({ ...updatedData }));
				successCallback({ ...updatedData });
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export const validatePart =
	(sequenceNumber, payload, successCallback, errorCallback) =>
	(dispatch, getState) => {
		axiosInstance
			.post(`/station/part-validation/${sequenceNumber}/validate`, {
				...payload,
			})
			.then((data) => {
				const { partValidation } = getState();
				const scanJobDetails = data.data.scanJobDetails.map((scanJob) => {
					if (scanJob.familyId === payload.familyId) {
						return { ...scanJob };
					}
					return { ...scanJob };
				});

				const updatedData = { ...partValidation, scanJobDetails };
				dispatch(updatePartValidation({ ...updatedData }));
				successCallback({ ...updatedData });
			})
			.catch((err) => {
				// console.log('errin validatePart', err);
				errorCallback(err);
			});
	};

export const revalidatePart =
	(sequenceNumber, idToUpdate, payload, successCallback, errorCallback) =>
	(dispatch, getState) => {
		const { partValidation } = getState();

		axiosInstance
			.post(
				`/station/part-validation/${sequenceNumber}/update-validation/${idToUpdate}`,
				{
					...payload,
				},
			)
			.then((response) => {
				const { data } = response;

				const scanJobDetails = data.scanJobDetails.map((scanJob) => {
					if (scanJob.familyId === payload.familyId) {
						const scanJobResults = scanJob.scanJobResults.map(
							(scanJobResult) => {
								if (scanJobResult.id === idToUpdate)
									return {
										...scanJobResult,
										scannedSerialNumber: payload.scannedSerialNumber,
										displaySerialNumber: payload.scannedSerialNumber,
										skipReason: null,
									};
								return { ...scanJobResult };
							},
						);

						return { ...scanJob, scanJobResults };
					}
					return { ...scanJob };
				});

				const updatedData = { ...partValidation, scanJobDetails };
				dispatch(updatePartValidation({ ...updatedData }));
				successCallback({ ...updatedData });
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export const bookSequenceNumber =
	(sequenceNumber, successCallback, errorCallback) => (dispatch) => {
		axiosInstance
			.post(`/station/book/${sequenceNumber}`)
			.then(() => {
				dispatch(updatePartValidation({}));
				dispatch(updateReceivePart({}));
				dispatch(updateCurrentLineItem(null));
				successCallback();
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export const updatePartValidation = (data) => (dipatch, getState) => {
	const { user } = getState();
	const { station } = user;

	const state = { ...data };

	const lineAndStationDataInLocalStorage =
		JSON.parse(localStorage.getItem(station.replaceAll(/[- ]/g, '_'))) || {};

	const lineAndStationData = {
		...lineAndStationDataInLocalStorage,
		partValidation: state,
	};
	localStorage.setItem(
		station.replaceAll(/[- ]/g, '_'),
		JSON.stringify(lineAndStationData),
	);

	dipatch({
		type: ActionTypes.UPDATE_PART_VALIDATION,
		...state,
	});
};

export const raiseExceptionRequest =
	(asn, payload, successCallback, errorCallback) => () => {
		axiosInstance
			.post(`/station/perform-privileged-action/${asn}`, { ...payload })
			.then(() => {
				successCallback();
			})
			.catch((err) => {
				errorCallback(err);
			});
	};

export function updateStatusFromScanJobDetails(targetArray = []) {
	let totalPendingGenologyCount = 0;
	return targetArray?.map((job, index) => {
		const scanJobResults = job?.scanJobResults || [];

		let isValidated = false;
		let status = 'Pending';

		if (scanJobResults.length > 0) {
			const validCount = scanJobResults?.filter((result) => {
				const hasSerial = result?.scannedSerialNumber !== null;
				const hasPart = result?.scannedPartNumber !== null;
				const notSkipped = result?.skipReason === null;

				if (job.genealogyRequired && job.partNumberScanningRequired) {
					return notSkipped && (hasSerial || hasPart);
				}
				if (job.genealogyRequired && !job.partNumberScanningRequired) {
					return notSkipped && hasSerial;
				}
				if (!job.genealogyRequired && job.partNumberScanningRequired) {
					return notSkipped && hasPart;
				}
				return false;
			})?.length;

			const skippedCount = scanJobResults?.filter(
				(r) => r.skipReason !== null,
			).length;

			if (validCount === job?.quantity && job?.quantity > 0) {
				isValidated = true;
				status = 'Validated';
			} else if (skippedCount > 0 && job?.quantity > 0) {
				status = 'Skipped';
			} else {
				isValidated = false;
				status="Pending"
			}

		}

		// Calculate scanned/processed count (validated + skipped)
		const validatedCount = scanJobResults?.filter(result => !result.skipReason).length || 0;
		const skippedCount = scanJobResults?.filter(result => result.skipReason).length || 0;
		const processedCount = validatedCount + skippedCount;
		
		const quantityDisplay = `${processedCount}/${job.quantity}`;

		return {
			id: index + 1,
			name: job.familyName,
			number: job.partNumber,
			description: job.partDescription,
			qty: quantityDisplay,
			serial: job.scanJobResults?.[0]?.scannedSerialNumber ?? '-',
			status: status,
			familyId: job.familyId,
			partNumber: job.partNumber,
			familyName: job.familyName,
			partDescription: job.partDescription,
			quantity: job.quantity,
			genealogyRequired: job.genealogyRequired,
			partNumberScanningRequired: job.partNumberScanningRequired,
			validParts: job.validParts,
			scanJobResults,
		};
	});
}
